import { render, staticRenderFns } from "./ReviewBar.vue?vue&type=template&id=4cd42194"
import script from "./ReviewBar.vue?vue&type=script&lang=js"
export * from "./ReviewBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports